const en = {
  "nav.home": "Home",
  "nav.about": "About",
  "nav.goToSongbo": "Visit Songbo Website",

  "footer.tagline": "A Brand Distributed by Songbo Publishing Co., Ltd.",
  "footer.subtitle": "A Curated Brand for Humanities, History & Classical Texts",
  "footer.goToSongbo": "Visit Songbo Website",
  "footer.copyright": "© {{year}} Fuko. All Rights Reserved.",

  "home.hero.subtitle": "A Brand Distributed by Songbo Publishing Co., Ltd.",
  "home.hero.brand": "Fuko",
  "home.hero.tagline": "Bringing Classics Back to Life",
  "home.hero.cta": "Visit Songbo Website",

  "home.brandIntro.imageTitle": "Fuko",
  "home.brandIntro.imageSubtitle": "Reorganize. Reinterpret.",
  "home.brandIntro.label": "Brand Philosophy",
  "home.brandIntro.heading": "Curating Humanities, History & Classical Texts for Today's Readers",
  "home.brandIntro.p1": "<0>Fuko</0> is a brand distributed by Songbo Publishing, focusing on classical texts, historical memory, and knowledge reinterpretation. We specialize in history, humanities and social sciences, public domain classics, and fiction.",
  "home.brandIntro.p2": "We believe that classics should not be confined to academic bookshelves. Through reorganization, reinterpretation, and redesign, we breathe new life into timeless texts for the modern age.",
  "home.brandIntro.statBooks": "Titles Published",
  "home.brandIntro.statAuthors": "Partner Authors",
  "home.brandIntro.learnMore": "Learn More",

  "home.featured.label": "Featured Publications",
  "home.featured.heading": "Recent Releases",
  "home.featured.subtitle": "Each book is a fresh interpretation of a classic, building a bridge between history, literature, and contemporary readers.",
  "home.featured.viewAll": "Browse Full Catalog on Songbo",

  "home.cta.heading": "Discover More Classics on Songbo",
  "home.cta.subtitle": "The complete Fuko catalog, latest news, and full bibliography — all on the Songbo Publishing official website. From history to literature, from public domain classics to contemporary works, explore in one place.",
  "home.cta.button": "Visit Songbo Website",

  "home.relationship.label": "Brand Relationship",
  "home.relationship.heading": "Fuko × Songbo Publishing",
  "home.relationship.p1": "<0>Fuko</0> is a brand distributed by Songbo Publishing Co., Ltd. With over two decades of professional publishing experience, Songbo Publishing possesses deep editorial expertise and distribution resources in the humanities and history categories. Fuko builds on this professional foundation, focusing on the curation of historical, humanistic, and classical texts.",

  "about.hero.label": "About",
  "about.hero.heading": "About the Brand",
  "about.hero.subtitle": "A brand distributed by <0>Songbo Publishing Co., Ltd.</0> — curating humanities, history, and classical texts.",

  "about.brandStory.imageTitle": "Brand Story",
  "about.brandStory.imageSubtitle": "Transcending Eras Through Words",
  "about.brandStory.heading": "Bringing Classics Back to Life",
  "about.brandStory.p1": "<0>Fuko</0> is a brand distributed by <1>Songbo Publishing Co., Ltd.</1>, specializing in history, humanities and social sciences, public domain classics, and fiction.",
  "about.brandStory.p2": "The name \"Fuko\" (複刻) draws inspiration from the traditional printing concept of recreating printing plates — remaking precious ancient texts so that classic works can be passed down. We extend this concept into our core philosophy: not merely replicating, but recreating; not merely reprinting, but reinterpreting.",
  "about.brandStory.p3": "We believe that classics should not be confined to academic bookshelves. Through reorganization, reinterpretation, and redesign, we breathe new life into timeless texts — turning history into an approachable conversation, making classics readable in the present.",

  "about.mission.title": "Mission",
  "about.mission.desc": "To make classical texts readable, understandable, and discussable in the contemporary world — building a bridge between historical and humanistic knowledge and modern readers.",
  "about.vision.title": "Vision",
  "about.vision.desc": "To become the most influential brand for curated humanities, history, and classical texts in the Chinese-speaking world, establishing a complete ecosystem of historical and humanistic knowledge.",
  "about.value.title": "Values",
  "about.value.desc": "Academic rigor, trustworthy content, collectible design. Every publication undergoes strict editorial review to ensure quality and depth.",

  "about.songbo.heading": "Fuko × Songbo Publishing",
  "about.songbo.p1": "<0>Fuko</0> is a brand distributed by Songbo Publishing Co., Ltd. With over two decades of professional publishing experience, Songbo Publishing possesses deep editorial expertise and distribution resources in academic publishing, textbooks, and humanities & history categories.",
  "about.songbo.backHome": "Back to Home",

  "bookCard.viewOnSongbo": "Songbo Website",

  "notFound.title": "This page has not been generated",
  "notFound.subtitle": "Tell me more about this page, so I can generate it",

  "lang.switchTo": "Language",

  "brand.imageAlt": "複刻文化 Fuko Brand Visual"
};

export default en;